import { BaseModel } from '../common/base-model/base-model';

export class AttendantServiceGroupServices extends BaseModel {
  constructor(
    public override id?: string,
    public attendant_service_group_id?: string,
    public service_id?: string,
    public deleted?: boolean,
  ) {
    super();
  }

  toJSON() {
    return {
      id: this.id,
      attendant_service_group_id: this.attendant_service_group_id,
      service_id: this.service_id,
      deleted: !!this.deleted,
    };
  }

  static fromJson(jsonData: any): AttendantServiceGroupServices {
    return Object.assign(new AttendantServiceGroupServices(), jsonData);
  }
}
